module.exports = __webpack_public_path__ + "media/images/no-devices-configured-71dfde0b4d2e632d34ec3cb714f23432.svg";